import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@core/hooks/useAuth';
import { Button } from '@shared/components/Button';
import { Input } from '@shared/components/Input';
import { Select } from '@shared/components/Select';

const RegisterPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [tenantName, setTenantName] = useState('');
  const [role, setRole] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }

    setIsLoading(true);

    try {
      await register(email, password, tenantName, role || undefined);
      navigate('/auth/login');
    } catch (err) {
      setError((err as Error).message || 'Error al registrar');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Crear Cuenta
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            ¿Ya tienes cuenta?{' '}
            <Link to="/auth/login" className="font-medium text-blue-600 hover:text-blue-500">
              Iniciar Sesión
            </Link>
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}
          <div className="rounded-md shadow-sm space-y-4">
            <Input
              type="text"
              label="Nombre de la empresa"
              value={tenantName}
              onChange={(e) => setTenantName(e.target.value)}
              required
              placeholder="Mi Empresa S.A."
            />
            <Input
              type="email"
              label="Correo electrónico"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@empresa.com"
            />
            <Input
              type="password"
              label="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="•••••••• (mínimo 8 caracteres)"
            />
            <Input
              type="password"
              label="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
            <Select
              label="Rol (opcional)"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              options={[
                { value: '', label: 'Seleccionar rol...' },
                { value: 'ADMIN', label: 'Administrador' },
                { value: 'INSPECTOR', label: 'Inspector' },
                { value: 'VIEWER', label: 'Visualizador' },
              ]}
            />
          </div>

          <div>
            <Button type="submit" fullWidth isLoading={isLoading}>
              Registrar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;